import { Grid } from '@mui/material';
import { useSurveyResponseFilters } from './hook';
import { SurveyResponseFiltersProps } from './props';
import dayjs from 'dayjs';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import FieldText from '../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';

export const SurveyResponseFilters = ({
    onFilter,
    loading,
}: SurveyResponseFiltersProps) => {
    const { formik, surveys } = useSurveyResponseFilters(onFilter);

    const statusOptions = [
        { id: '', name: 'Todos' },
        { id: 'completed', name: 'Completada' },
        { id: 'incomplete', name: 'Incompleta' },
    ];

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={statusOptions}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={surveys}
                    label="Encuesta"
                    name="surveyId"
                    size="small"
                    touched={formik.touched.surveyId}
                    errors={formik.errors.surveyId}
                    value={formik.values.surveyId as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Código Encuesta"
                    name="surveyCode"
                    size="small"
                    touched={formik.touched.surveyCode}
                    errors={formik.errors.surveyCode}
                    value={formik.values.surveyCode}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número de Documento"
                    name="documentNumber"
                    size="small"
                    touched={formik.touched.documentNumber}
                    errors={formik.errors.documentNumber}
                    value={formik.values.documentNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre Cliente"
                    name="customerName"
                    size="small"
                    touched={formik.touched.customerName}
                    errors={formik.errors.customerName}
                    value={formik.values.customerName}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Servicio Asociado"
                    name="associatedService"
                    size="small"
                    touched={formik.touched.associatedService}
                    errors={formik.errors.associatedService}
                    value={formik.values.associatedService}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <DatePickerField
                    size="small"
                    label="Fecha Desde"
                    name="startDate"
                    touched={formik.touched.startDate}
                    errors={formik.errors.startDate}
                    value={
                        formik.values.startDate
                            ? dayjs(formik.values.startDate)
                            : null
                    }
                    onChange={(value: any) => {
                        formik.setFieldValue(
                            'startDate',
                            value ? value.format('YYYY-MM-DD') : ''
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <DatePickerField
                    size="small"
                    label="Fecha Hasta"
                    name="endDate"
                    touched={formik.touched.endDate}
                    errors={formik.errors.endDate}
                    value={
                        formik.values.endDate
                            ? dayjs(formik.values.endDate)
                            : null
                    }
                    onChange={(value: any) => {
                        formik.setFieldValue(
                            'endDate',
                            value ? value.format('YYYY-MM-DD') : ''
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
